export default __webpack_public_path__ + "f0c44193f775d60e1e957cf72c5fa465.svg";